import { FC } from 'react';
import { LocationDashboard } from 'src/pages/Location/LocationDashboard';

export const LocationPage: FC = () => {
  return <LocationDashboard />;
};
